import CallToAction from './CallToAction'

export default CallToAction
